import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import TariffHistory from './tariff-history';
import TariffHistoryDetail from './tariff-history-detail';
import TariffHistoryUpdate from './tariff-history-update';
import TariffHistoryDeleteDialog from './tariff-history-delete-dialog';

const TariffHistoryRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<TariffHistory />} />
    <Route path="new" element={<TariffHistoryUpdate />} />
    <Route path=":id">
      <Route index element={<TariffHistoryDetail />} />
      <Route path="edit" element={<TariffHistoryUpdate />} />
      <Route path="delete" element={<TariffHistoryDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default TariffHistoryRoutes;
